function attachViolationNoteCorrection () {
  const violationForm = document.querySelector('#violation_note_form')

  if (!violationForm) {
    return
  }

  violationForm.addEventListener('submit', function () {
    const isCorrection = document.getElementById('note_correction').checked

    if (isCorrection) {
      const noteValue = document.getElementById('note_text').value

      document.getElementById('note_text').value = `This is a correction: ${noteValue}`
    }
  })
}

document.addEventListener('DOMContentLoaded', function () {
  attachViolationNoteCorrection()
})
